import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

import { SERVICE_OPTIONS } from "@/data/site";

const empty = { name: "", phone: "", email: "", service: "", dog: "", message: "" };

export const ContactForm = ({ defaultService = "" }) => {
  const [form, setForm] = useState({ ...empty, service: defaultService });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const fields = [
      "Olá DOG'Z! Gostaria de pedir um orçamento.",
      `Nome: ${form.name}`,
      `Telefone: ${form.phone}`,
      form.email ? `Email: ${form.email}` : null,
      `Serviço: ${SERVICE_OPTIONS.find((o) => o.value === form.service)?.label || form.service}`,
      form.dog ? `Cão: ${form.dog}` : null,
      form.message ? `Mensagem: ${form.message}` : null,
    ].filter(Boolean);
    const url = `https://wa.me/351936225295?text=${encodeURIComponent(fields.join("\n"))}`;
    // O cliente confirma o envio no WhatsApp; o site não guarda os dados.
    window.location.href = url;
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
      <input required minLength={2} className="field" placeholder="Nome *" value={form.name} onChange={set("name")} data-testid="contact-name-input" />
      <input required minLength={6} type="tel" className="field" placeholder="Telefone *" value={form.phone} onChange={set("phone")} data-testid="contact-phone-input" />
      <input type="email" className="field" placeholder="Email" value={form.email} onChange={set("email")} data-testid="contact-email-input" />
      <select required className="field" value={form.service} onChange={set("service")} data-testid="contact-service-select">
        <option value="" disabled>Serviço pretendido *</option>
        {SERVICE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <input className="field sm:col-span-2" placeholder="Nome e raça do cão" value={form.dog} onChange={set("dog")} data-testid="contact-dog-input" />
      <textarea rows={4} className="field resize-none sm:col-span-2" placeholder="Mensagem (datas, idade do cão, dúvidas...)" value={form.message} onChange={set("message")} data-testid="contact-message-input" />
      <div className="sm:col-span-2">
        <button
          type="submit"
          data-testid="contact-submit-button"
          className="group inline-flex items-center gap-3 rounded-full bg-[#C8D484] px-8 py-4 font-bold text-black transition-transform duration-300 hover:scale-[1.03] "
        >
          Pedir orçamento pelo WhatsApp
          <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </form>
  );
};
